import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/transport',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/transport/workbench',
      name: 'workbench',
      component: () => import('@/pages/transport/transport-workbench.vue'),
      meta: {
        ...meta,
        title: '我的工作台',
        requireAuth: true
      }
    },

    {
      path: '/transport/workbenchInfo',
      name: 'transport_workbenchInfo',
      component: () => import('@/pages/transport/workbenchInfo.vue'),
      meta: {
        ...meta,
        title: '工作台消息',
        requireAuth: true
      }
    },
    {
      path: '/transport/platform',
      name: 'transport_platform',
      component: () => import('@/pages/transport/transport-platform/transport-platform.vue'),
      meta: {
        ...meta,
        title: '多式联运智能匹配平台'
      }
    },
    {
      path: '/transport/platform/shipManage',
      name: 'transport_platform_shipManage',
      component: () => import('@/pages/transport/transport-platform/transport-platform-shipManage.vue'),
      meta: {
        ...meta,
        title: '船舶管理',
        requireAuth: true
      }
    },
    {
      path: '/transport/changeRequirement',
      name: 'changeRequirement',
      component: () => import('@/pages/transport/transport-changeRequirement.vue'),
      meta: {
        ...meta,
        title: '需求变更',
        requireAuth: true
      }
    },
    {
      path: '/transport/phaseTransportDemand',
      name: 'phaseTransportDemand',
      component: () => import('@/pages/myOrders/phaseTransportDemand.vue'),
      meta: {
        ...meta,
        title: '阶段运输需求',
        requireAuth: true
      }
    },
    {
      path: '/transport/phaseTransportDemand/phaseTransportDemandDetail',
      name: 'phaseTransportDe',
      component: () => import('@/pages/myOrders/phaseTransportDemandDetail.vue'),
      meta: {
        ...meta,
        title: '阶段运输详情',
        requireAuth: true
      }
    },
    {
      path: '/transport/phaseTransportDemand/phaseTransportDemandNew',
      name: 'phaseTransportD',
      props: true,
      component: () => import('@/pages/shipmentBusiness/phaseTransportDemandNew.vue'),
      meta: {
        ...meta,
        title: '阶段运输需求新建',
        requireAuth: true
      }
    },
    {
      path: '/transport/phaseTransportDemand/phaseDemandInfoSupple',
      name: 'phaseTransportDem',
      component: () => import('@/pages/transport/transport-phaseTransportDemand/phaseDemandInfoSupple.vue'),
      meta: {
        ...meta,
        title: "阶段信息补充修改",
        requireAuth: true
     }
    },
    {
      path: '/transport/phaseTransportDemand/phaseTransportDemandRes',
      name: 'phaseTransportDema',
      component: () => import('@/pages/transport/transport-phaseTransportDemand/transport-phaseTransportDemand-resultDemand.vue'),
      meta: {
        ...meta,
        title: '阶段运输结果页',
        requireAuth: true
      }
    },
    {
      path: '/transport/wayBillInfo/wayBillInfo',
      name: 'wayBillInfo',
      component: () => import('@/pages/transport/wayBillInfo/wayBillInfo.vue'),
      meta: {
        ...meta,
        title: '运单管理',
        requireAuth: true
      }
    },
    // {
    //   path: '/transport/leagueOfNationsWaybill/LNWayBillAdd',
    //   name: 'LNWayBillAdd',
    //   component: () => import('@/pages/transport/leagueOfNationsWaybill/LNWayBillAdd.vue'),
    //   meta: {
    //     ...meta,
    //     title: '国联运单新建',
    //     requireAuth: true
    //   }
    // },
    {
      path: '/transport/dailyTransportDemand',
      name: 'dailyTransportDemand',
      component: () => import('@/pages/myOrders/dailyTransportDemand.vue'),
      meta: {
        ...meta,
        title: '日运输需求',
        requireAuth: true
      }
    },
    //测试页
    // {
    //   path: 'test',
    //   name: 'test',
    //   meta: {
    //     auth: true
    //   },
    //   component: () => import('@/pages/test.vue')
    // },
    {
      path: '/transport/dailyTransportDemand/dailyTransportDemandDetail',
      name: 'dailyTransportDeman',
      component: () => import('@/pages/myOrders/dailyTransportDemandDetail.vue'),
      meta: {
        ...meta,
        title: '日运输详情',
        requireAuth: true
      }
    },
    {
      path: '/transport/dailyTransportDemand/dailygoodsOrder',
      name: 'daily_dailygoodsOrder',
      component: () => import('@/pages/transport/transport-dailyTransportDemand/dailygoodsOrder.vue'),
      meta: {
        ...meta,
        title: '运单详情',
        requireAuth: true
      }
    },
    // {
    //   path: '/transport/containerDemand',
    //   name: 'container',
    //   component: () => import('@/pages/transport/transport-container/transport-containerDemand.vue'),
    //   meta: {
    //     ...meta,
    //     title: '集装箱',
    //     requireAuth: true
    //   }
    // },
    // {
    //   path: '/transport/dailyTransportDemand/dailyTransportDemandNew/:type',
    //   name: 'dailyTransport',
    //   component: () => import('@/pages/transport/transport-dailyTransportDemand/dailyTransportDemandNew.vue'),
    //   meta: {
    //     ...meta,
    //     title: '日需求新建',
    //     requireAuth: true
    //   }
    // },
    {
      path: '/transport/dailyTransportDemand/dailyTransportDemandRes',
      name: 'dailyTransportDem',
      component: () => import('@/pages/transport/transport-dailyTransportDemand/transport-dailyTransportDemand-dailyTransportDemandRes.vue'),
      meta: {
        ...meta,
        title: '日需求结果页',
        requireAuth: true
      }
    },
    {
      path: '/transport/dailyTransportDemand/shippingSupplementInfo',
      name: 'dailyTransportDema',
      component: () => import('@/pages/transport/transport-dailyTransportDemand/transport-dailyTransportDemand-shippingSupplementInfo.vue'),
      meta: {
        ...meta,
        title: '待审核修改',
        requireAuth: true
      }
    },
    {
      path: '/transport/dailyTransportDemand/transportResourceReservation',
      name: 'dailyTransportDe',
      component: () => import('@/pages/transport/transport-dailyTransportDemand/transport-dailyTransportDemand-transportResourceReservation/transport-dailyTransportDemand-transportResourceReservation.vue'),
      meta: {
        ...meta,
        title: '运输资源预定',
        requireAuth: true
      }
    },
    {
      path: '/transport/dailyTransportDemand/transportResourceReservationSelect',
      name: 'transport_dailyTransportDemand_transportResourceReservationSelect',
      component: () => import('@/pages/transport/transport-dailyTransportDemand/transport-dailyTransportDemand-transportResourceReservation/transport-dailyTransportDemand-transportResourceReservationSelect.vue'),
      meta: {
        ...meta,
        title: '运输资源预定查询',
        requireAuth: true
      }
    },
    {
      path: '/transport/dailyTransportDemand/multimodalTransport',
      name: 'daily_dailyTransportDe',
      component: () => import('@/pages/transport/transport-dailyTransportDemand/transport-dailyTransportDemand-multimodalTransport.vue'),
      meta: {
        ...meta,
        title: '多式联运',
        requireAuth: true
      }
    },
    {
      path: '/transport/dailyTransportDemand/arriveChange/arriveChangeInput',
      name: 'arriveChangeInput',
      component: () => import('@/pages/transport/transport-dailyTransportDemand/transport-dailyTransportDemand-arriveChange-arriveChangeInput.vue'),
      meta: {
        ...meta,
        title: '到达变更录入',
        requireAuth: true
      }
    },
    {
      path: '/transport/dailyTransportDemand/dailyTransportDemandUnsubscribe',
      name: 'dailyDemandUnsubscribe',
      component: () => import('@/pages/transport/transport-dailyTransportDemand/transport-dailyTransportDemandUnsubscribe.vue'),
      meta: {
        ...meta,
        title: '日需求退订',
        requireAuth: true
      }
    },
    // {
    //   path: '/transport/transport-LoadUnloadVehicleInfo',
    //   name: 'loadUnloadVehicleInfo',
    //   component: () => import('@/pages/transport/transport-LoadUnloadVehicleInfo.vue'),
    //   meta: {
    //     ...meta,
    //     title: '装卸车信息',
    //     requireAuth: true
    //   }
    // },
    // {
    //   path: '/transport/cargoTracking',
    //   name: 'transport_cargoTracking',
    //   component: () => import('@/pages/transport/transport-cargoTracking/transport-cargoTracking.vue'),
    //   meta: {
    //     ...meta,
    //     title: '货物追踪',
    //     requireAuth: true
    //   }
    // },
    {
      path: '/transport/goodsDelivery',
      name: 'transport_goodsDelivery',
      component: () => import('@/pages/transport/transport-goodsDelivery/transport-goodsDelivery.vue'),
      meta: {
        ...meta,
        title: '货物交付'
      }
    },
    {
      path: '/transport/orderDelivery',
      name: 'transport_orderDelivery',
      component: () => import('@/pages/transport/transport-goodsDelivery/transport-orderDelivery.vue'),
      meta: {
        ...meta,
        title: '交付交割单'
      }
    },
    {
      path: '/transport/claimSettlementService',
      name: 'claimSettlementService',
      component: () => import('@/pages/transport/transport-claimSettlementService/transport-claimSettlementService.vue'),
      meta: {
        ...meta,
        title: '理赔信息',
        requireAuth:true
      }
    },
    {
      path: '/transport/claimSettlementService/claimProcess',
      name: 'claimProcess',
      component: () => import('@/pages/transport/transport-claimSettlementService/transport-claimSettlementService-claimProcess.vue'),
      meta: {
        ...meta,
        title: '理赔流程'
      }
    },
    {
      path: '/transport/claimSettlementService/freightRecord',
      name: 'claimSettlement',
      component: () => import('@/pages/transport/transport-claimSettlementService/transport-claimSettlementService-freightRecord.vue'),
      meta: {
        ...meta,
        title: '货运记录',
        requireAuth: true
      }
    },
    {
      path: '/transport/claimSettlementService/claimSettlement',
      name: 'claimSettlemen',
      component: () => import('@/pages/transport/transport-claimSettlementService/transport-claimSettlementService-claimSettlement.vue'),
      meta: {
        ...meta,
        title: '申请理赔',
        requireAuth: true
      }
    },
    {
      path: '/transport/claimSettlementService/customerNotice',
      name: 'customerNotice',
      component: () => import('@/pages/transport/transport-claimSettlementService/transport-claimSettlementService-customerNotice.vue'),
      meta: {
        ...meta,
        title: '查看客户通知书',
        requireAuth: true
      }
    },
    {
      path: '/transport/contractManagement_1',
      name: 'contractManagement',
      component: () => import('@/pages/transport/transport-contractManagement_1/transport-contractManagement_1.vue'),
      meta: {
        ...meta,
        title: '合同管理',
        requireAuth: true
      }
    },
    {
      path: '/transport/contractManagement_1/contractSigning',
      name: 'contract',
      component: () => import('@/pages/transport/transport-contractManagement_1/transport-contractManagement_1-contractSigning.vue'),
      meta: {
        ...meta,
        title: '合同签订',
        requireAuth: true
      }
    },
    {
      path: '/transport/contractManagement_1/contractModif',
      name: 'contrac',
      component: () => import('@/pages/transport/transport-contractManagement_1/transport-contractManagement_1-contractModif.vue'),
      meta: {
        ...meta,
        title: '合同修改',
        requireAuth: true
      }
    },
    {
      path: '/transport/workbench/msgboard',
      name: 'transport_workbench_msgboard',
      component: () => import('@/pages/transport/transport-msgboard/transport-msgboard.vue'),
      meta: {
        ...meta,
        title: '留言板',
        requireAuth: true
      }
    },
    {
      path: '/transport/workbench/msgboardetail',
      name: 'transport_workbench_msgboardetail',
      component: () => import('@/pages/transport/transport-msgboard/transport-msgboardetail.vue'),
      meta: {
        ...meta,
        title: '留言板详情',
        requireAuth: true
      }
    },
    {
      path: '/transport/workbench/myboard',
      name: 'transport_workbench_myboard',
      component: () => import('@/pages/transport/transport-msgboard/transport-myboard.vue'),
      meta: {
        ...meta,
        title: '我的留言板',
        requireAuth: true
      }
    },
    {
      path: '/transport/freightCharges',
      name: 'freightCharges',
      component: () => import('@/pages/transport/transport-freightCharges/transport-freightCharges.vue'),
      meta: {
        ...meta,
        title: '运费支付',
        requireAuth: true
      }
    },
    {
      path: '/transport/freightCharges/details',
      name: 'freightCharge',
      component: () => import('@/pages/transport/transport-freightCharges/transport-freightCharges-details.vue'),
      meta: {
        ...meta,
        title: '交易明细',
        requireAuth: true
      }
    },
   // {
   //  path: '/transport/leagueOfNationsWaybill',
   //  name: 'leagueOfNationsWaybill',
   //  component: () => import('@/pages/index/page.vue'),
   //  meta: {
   //  ...meta,
   //  title: '国联运单',
   //  requireAuth: true
   // }
   //  },
    {
      path: '/transport/freightCharges/order',
      name: 'freight_charges_order',
      component: () => import('@/pages/transport/transport-freightCharges/order.vue'),
      meta: {
        ...meta,
        title: '货物运单',
        requireAuth: true
      }
    },
  ]
}
